import { methods } from "../../utils/axios";

export default class ConceptsAPI {
  static listConcepts(data){
    return methods.post('/concepts_list', data);
  }
  static getConceptsExcel(){
    return methods.download('/concepts/excel');
  }
}